<script lang="ts">
  import { get } from 'svelte/store';
  import { gameAudio, gameAudioTrack, requiresTap } from './stores';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  function playMedia() {
    const isVideoPlaying = playVideo();
    const isAudioPlaying = playAudio();

    if (!isVideoPlaying || !isAudioPlaying) {
      console.log(
        'we should handle the case here where the media is not playing',
      );
    }
    $requiresTap = false;
  }

  function playVideo() {
    try {
      (document.getElementById('video') as HTMLVideoElement).play();
      return true;
    } catch (error) {
      console.log('error playing video source');
      return false;
    }
  }

  function playAudio(): boolean {
    const audioContext = new (window.AudioContext ||
      // @ts-ignore
      window.webkitAudioContext)();
    console.log('audio context', audioContext.state);
    if (audioContext.state !== 'running') {
      try {
        $gameAudio.play();
        return true;
      } catch (error) {
        console.log('error playing audio');
        return false;
      }
    }

    setTimeout(() => {
      dispatch('message', {
        event: 'soundconnected',
      });
    }, 50);
  }
</script>

<div class="tap_to_start_overlay" on:click={playMedia}>
  <div class="instructions">Tap the screen to start playing.</div>
</div>

<style>
  .tap_to_start_overlay {
    align-items: center;
    background-color: black;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 0.5;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 5000;
  }
  .tap_to_start_overlay .instructions {
    color: #ffc107; /* MTN Yellow */
    font-size: x-large;
    font-weight: 500;
  }
</style>
